// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(120deg, #A5D6A7, #004D40, #F0F8E7);
  background-size: 300% 300%;
  animation: gradient-bg 8s ease infinite;
}

@keyframes gradient-bg {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.login-form {
  background: #A5D6A7;
  backdrop-filter: blur(8px);
  padding: 30px;
  border-radius: 15px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 20px;
  animation: fadeIn 1s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-form h1 {
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
}

.error-message4 {
  background-color: #ffcccc;
  color: #d32f2f;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
  width: 80%;
}

.input-field {
  width: 92%;
  padding: 10px 14px;
  border: none;
  border-radius: 6px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.6);
  transition: border 0.3s, background 0.3s;
}

.input-field:focus {
  outline: none;
  border: 2px solid #4a90e2;
  background: rgba(255, 255, 255, 0.85);
}

select.input-field {
  appearance: none;
  cursor: pointer;
}

.submit-buttonnn {
  width: 100%;
  padding: 12px 0;
  background-color: #004D40;
  color: white;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
}

.submit-buttonnn:hover {
  background-color: #357ab8;
}

.submit-buttonnn:active {
  transform: scale(0.98);
}

.password-wrapper {
  position: relative;
  width: 100%;
}

.password-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #004D40;
  font-size: 18px;
}

.password-toggle:hover {
  color: #357ab8;
}

.forgot-password-link {
  color: #004D40;
  font-size: 14px;
  text-align: center;
  margin-top: -2px;
  margin-bottom: 2px;
  cursor: pointer;
  text-decoration: underline;
  width: 100%;
  display: block;
}

.forgot-password-link:hover {
  color: #357ab8;
}

.MuiModal-root {
  backdrop-filter: blur(5px);
}

.MuiBox-root {
  outline: none;
}

.MuiTextField-root {
  margin-bottom: 16px;
}

.MuiButton-contained {
  background-color: #004D40;
}

.MuiButton-contained:hover {
  background-color: #357ab8;
}

.MuiModal-root {
  backdrop-filter: blur(5px);
}

.MuiBox-root {
  outline: none;
  margin: 16px !important;
  max-width: calc(100vw - 32px) !important;
  max-height: calc(100vh - 32px) !important;
  overflow-y: auto;
}

.MuiModal-root {
  backdrop-filter: blur(5px);
}

.MuiBox-root {
  outline: none;
  margin: 16px !important;
  max-width: 350px !important;
  width: 90% !important;
  max-height: calc(100vh - 32px) !important;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .MuiBox-root {
    margin: 8px !important;
    max-width: 320px !important;
    width: 85% !important;
    padding: 20px !important;
    border-radius: 12px !important;
  }
  
  .MuiTextField-root {
    margin-bottom: 12px;
  }
  
  .MuiTextField-root .MuiInputBase-root {
    font-size: 16px !important; 
    padding: 8px 12px !important; 
    min-height: auto !important;
  }
  
  .MuiTextField-root .MuiInputBase-input {
    padding: 8px 0 !important; 
  }
  
  .MuiDialogActions-root,
  .MuiBox-root > div:last-child {
    display: flex !important;
    justify-content: center !important;
    gap: 12px !important;
    margin-top: 16px !important;
  }
  
  .MuiButton-contained,
  .MuiButton-outlined {
    background-color: #004D40;
    padding: 8px 16px !important;
    font-size: 14px !important;
    min-width: 80px !important;
    max-width: 100px !important;
  }
  
  .MuiButton-contained:hover {
    background-color: #357ab8;
  }
  
  .MuiButton-outlined {
    background-color: transparent !important;
    border-color: #004D40 !important;
    color: #004D40 !important;
  }
  
  .MuiButton-outlined:hover {
    background-color: rgba(0, 77, 64, 0.1) !important;
    border-color: #357ab8 !important;
  }
  
  .MuiTypography-h6 {
    font-size: 1.1rem !important;
    margin-bottom: 16px !important;
  }
  
  .MuiFormControl-root {
    width: 100% !important;
  }
}

@media (max-width: 480px) {
  .MuiBox-root {
    margin: 4px !important;
    max-width: 280px !important;
    width: 80% !important;
    padding: 16px !important;
    border-radius: 8px !important;
  }
  
  .MuiTextField-root .MuiInputBase-root {
    padding: 6px 10px !important;
  }
  
  .MuiTextField-root .MuiInputBase-input {
    padding: 6px 0 !important;
  }
  
  .MuiButton-contained,
  .MuiButton-outlined {
    padding: 6px 14px !important;
    font-size: 13px !important;
    min-width: 70px !important;
    max-width: 90px !important;
  }
}

@media (max-width: 768px) and (orientation: landscape) {
  .MuiBox-root {
    max-height: calc(100vh - 16px) !important;
    margin: 8px !important;
    max-width: 300px !important;
  }
}

@media (max-width: 768px) {
  .login-form {
    max-width: 320px;
    padding: 24px;
    border-radius: 12px;
    gap: 16px;
  }

  .login-form h1 {
    font-size: 20px;
  }

  .input-field {
    font-size: 13px;
  }

  .submit-buttonnn {
    font-size: 14px;
    padding: 10px 0;
  }
}

@media (max-width: 480px) {
  .login-form {
    max-width: 256px; 
    padding: 20px;
    border-radius: 10px;
    gap: 14px;
  }

  .login-form h1 {
    font-size: 18px;
  }

  .input-field {
    font-size: 12px;
  }

  .submit-buttonnn {
    font-size: 13px;
    padding: 8px 0;
  }
}

.signup-redirect {
  text-align: center;
  font-size: 14px;
  color: #333;
  margin-top: -4px;
  margin-bottom: 4px;
}

.signup-redirect span {
  color: #004D40;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
}

.signup-redirect span:hover {
  color: #357ab8;
}

.input-field {
  width: 100%;
  padding: 10px 14px;
  padding-right: 44px;
  border: none;
  border-radius: 6px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.6);
  transition: border 0.3s, background 0.3s;
  box-sizing: border-box;
}

.error-message4 {
  background-color: #ffcccc;
  color: #d32f2f;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .input-field {
    font-size: 13px;
    padding: 10px 14px;
    padding-right: 40px;
  }
}

@media (max-width: 480px) {
  .input-field {
    font-size: 12px;
    padding: 8px 10px;
    padding-right: 36px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,8DAA8D;EAC9D,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,wCAAwC;EACxC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,qBAAqB;IACrB,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,wBAAwB;IACxB,kCAAkC;IAClC,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;IACzB,4BAA4B;IAC5B,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wCAAwC;IACxC,gCAAgC;IAChC,yBAAyB;EAC3B;;EAEA;IACE,iDAAiD;IACjD,gCAAgC;EAClC;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,qBAAqB;IACrB,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,4BAA4B;IAC5B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,sBAAsB;IACtB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,oCAAoC;EACpC,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;AACF","sourcesContent":[".login-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: linear-gradient(120deg, #A5D6A7, #004D40, #F0F8E7);\n  background-size: 300% 300%;\n  animation: gradient-bg 8s ease infinite;\n}\n\n@keyframes gradient-bg {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.login-form {\n  background: #A5D6A7;\n  backdrop-filter: blur(8px);\n  padding: 30px;\n  border-radius: 15px;\n  width: 100%;\n  max-width: 400px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  animation: fadeIn 1s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-form h1 {\n  font-family: \"Inter\", sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.error-message4 {\n  background-color: #ffcccc;\n  color: #d32f2f;\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  text-align: center;\n  width: 80%;\n}\n\n.input-field {\n  width: 92%;\n  padding: 10px 14px;\n  border: none;\n  border-radius: 6px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  background: rgba(255, 255, 255, 0.6);\n  transition: border 0.3s, background 0.3s;\n}\n\n.input-field:focus {\n  outline: none;\n  border: 2px solid #4a90e2;\n  background: rgba(255, 255, 255, 0.85);\n}\n\nselect.input-field {\n  appearance: none;\n  cursor: pointer;\n}\n\n.submit-buttonnn {\n  width: 100%;\n  padding: 12px 0;\n  background-color: #004D40;\n  color: white;\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s;\n}\n\n.submit-buttonnn:hover {\n  background-color: #357ab8;\n}\n\n.submit-buttonnn:active {\n  transform: scale(0.98);\n}\n\n.password-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #004D40;\n  font-size: 18px;\n}\n\n.password-toggle:hover {\n  color: #357ab8;\n}\n\n.forgot-password-link {\n  color: #004D40;\n  font-size: 14px;\n  text-align: center;\n  margin-top: -2px;\n  margin-bottom: 2px;\n  cursor: pointer;\n  text-decoration: underline;\n  width: 100%;\n  display: block;\n}\n\n.forgot-password-link:hover {\n  color: #357ab8;\n}\n\n.MuiModal-root {\n  backdrop-filter: blur(5px);\n}\n\n.MuiBox-root {\n  outline: none;\n}\n\n.MuiTextField-root {\n  margin-bottom: 16px;\n}\n\n.MuiButton-contained {\n  background-color: #004D40;\n}\n\n.MuiButton-contained:hover {\n  background-color: #357ab8;\n}\n\n.MuiModal-root {\n  backdrop-filter: blur(5px);\n}\n\n.MuiBox-root {\n  outline: none;\n  margin: 16px !important;\n  max-width: calc(100vw - 32px) !important;\n  max-height: calc(100vh - 32px) !important;\n  overflow-y: auto;\n}\n\n.MuiModal-root {\n  backdrop-filter: blur(5px);\n}\n\n.MuiBox-root {\n  outline: none;\n  margin: 16px !important;\n  max-width: 350px !important;\n  width: 90% !important;\n  max-height: calc(100vh - 32px) !important;\n  overflow-y: auto;\n}\n\n@media (max-width: 768px) {\n  .MuiBox-root {\n    margin: 8px !important;\n    max-width: 320px !important;\n    width: 85% !important;\n    padding: 20px !important;\n    border-radius: 12px !important;\n  }\n  \n  .MuiTextField-root {\n    margin-bottom: 12px;\n  }\n  \n  .MuiTextField-root .MuiInputBase-root {\n    font-size: 16px !important; \n    padding: 8px 12px !important; \n    min-height: auto !important;\n  }\n  \n  .MuiTextField-root .MuiInputBase-input {\n    padding: 8px 0 !important; \n  }\n  \n  .MuiDialogActions-root,\n  .MuiBox-root > div:last-child {\n    display: flex !important;\n    justify-content: center !important;\n    gap: 12px !important;\n    margin-top: 16px !important;\n  }\n  \n  .MuiButton-contained,\n  .MuiButton-outlined {\n    background-color: #004D40;\n    padding: 8px 16px !important;\n    font-size: 14px !important;\n    min-width: 80px !important;\n    max-width: 100px !important;\n  }\n  \n  .MuiButton-contained:hover {\n    background-color: #357ab8;\n  }\n  \n  .MuiButton-outlined {\n    background-color: transparent !important;\n    border-color: #004D40 !important;\n    color: #004D40 !important;\n  }\n  \n  .MuiButton-outlined:hover {\n    background-color: rgba(0, 77, 64, 0.1) !important;\n    border-color: #357ab8 !important;\n  }\n  \n  .MuiTypography-h6 {\n    font-size: 1.1rem !important;\n    margin-bottom: 16px !important;\n  }\n  \n  .MuiFormControl-root {\n    width: 100% !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .MuiBox-root {\n    margin: 4px !important;\n    max-width: 280px !important;\n    width: 80% !important;\n    padding: 16px !important;\n    border-radius: 8px !important;\n  }\n  \n  .MuiTextField-root .MuiInputBase-root {\n    padding: 6px 10px !important;\n  }\n  \n  .MuiTextField-root .MuiInputBase-input {\n    padding: 6px 0 !important;\n  }\n  \n  .MuiButton-contained,\n  .MuiButton-outlined {\n    padding: 6px 14px !important;\n    font-size: 13px !important;\n    min-width: 70px !important;\n    max-width: 90px !important;\n  }\n}\n\n@media (max-width: 768px) and (orientation: landscape) {\n  .MuiBox-root {\n    max-height: calc(100vh - 16px) !important;\n    margin: 8px !important;\n    max-width: 300px !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .login-form {\n    max-width: 320px;\n    padding: 24px;\n    border-radius: 12px;\n    gap: 16px;\n  }\n\n  .login-form h1 {\n    font-size: 20px;\n  }\n\n  .input-field {\n    font-size: 13px;\n  }\n\n  .submit-buttonnn {\n    font-size: 14px;\n    padding: 10px 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-form {\n    max-width: 256px; \n    padding: 20px;\n    border-radius: 10px;\n    gap: 14px;\n  }\n\n  .login-form h1 {\n    font-size: 18px;\n  }\n\n  .input-field {\n    font-size: 12px;\n  }\n\n  .submit-buttonnn {\n    font-size: 13px;\n    padding: 8px 0;\n  }\n}\n\n.signup-redirect {\n  text-align: center;\n  font-size: 14px;\n  color: #333;\n  margin-top: -4px;\n  margin-bottom: 4px;\n}\n\n.signup-redirect span {\n  color: #004D40;\n  text-decoration: underline;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.signup-redirect span:hover {\n  color: #357ab8;\n}\n\n.input-field {\n  width: 100%;\n  padding: 10px 14px;\n  padding-right: 44px;\n  border: none;\n  border-radius: 6px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  background: rgba(255, 255, 255, 0.6);\n  transition: border 0.3s, background 0.3s;\n  box-sizing: border-box;\n}\n\n.error-message4 {\n  background-color: #ffcccc;\n  color: #d32f2f;\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  text-align: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .input-field {\n    font-size: 13px;\n    padding: 10px 14px;\n    padding-right: 40px;\n  }\n}\n\n@media (max-width: 480px) {\n  .input-field {\n    font-size: 12px;\n    padding: 8px 10px;\n    padding-right: 36px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
